import ActionTypes from "../action-types";
import { GTM_EVENTS } from "../track-params";

/**
 * @module Turn
 * @class
 * @internal
 */
class Turn {
    constructor(options = {}) {
        this.options = options;
        this.name = "Turn";
        this.optOut = false;
        this.initiated = false;
        this.pageViewScript = '//d.turn.com/r/dft/id/L21rdC83ODEvcGlkLzcxNTMxMTU2L3QvMA';
        this.turnAddToCart = '//d.turn.com/r/dd/id/L21rdC83ODEvY2lkLzI4NjU3MjYwL3QvMg/kv/PrdNameATC=';
    }

    /**
     *
     * @method pageView
     * @param {String} eventName
     * @param {Object} params
     * @returns {Promise}
     * @internal
     */
     
    pageView(...args) {
        // Create the event.
        return this.track(...args);
    }

    /**
     *
     * @method track
     * @param {String} eventName
     * @param {Object} params
     * @returns {Promise}
     * @internal
     */

    track(eventName, params) {
        try{
            let {event} = params;
            
            switch(event){
                case GTM_EVENTS[ActionTypes.ADD_TO_CART]:
                    let {ecommerce : {add : {products}}} = params;
                    let skus = products.reduce(function(acc, cur){{
                        acc.push(cur.id);
                        return acc;
                    }}, []);
                    let encodeSKU = encodeURIComponent(skus.join(','));
                    new Image().src = this.turnAddToCart + encodeSKU;
                    break;

                case GTM_EVENTS[ActionTypes.LOCATION_CHANGE]:
                    if(!this.initiated){
                        var D = document, S = D.createElement('script');
                        S.src = this.pageViewScript;
                        S.async = true;
                        D.getElementsByTagName('head')[0].appendChild(S);

                        this.initiated = true;
                    }

                    break;

                default:
            }
        } catch (e){

        }
        
    }

}

export default Turn;